import { AppSettingsUrlBase } from "./appSettings.base";

export class AppSettingsUrl extends AppSettingsUrlBase {
	public static debug: boolean = false;
	public static apiUrl = AppSettingsUrlBase.releaseApiUrl;
}

